<template>
  <v-app>
    <v-main>
      <slot />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import loader from '../utils/loader';

export default {
  components: {
    Footer: loader.component('Footer'),
  },
};
</script>
